initExpertEndorsements();

function initExpertEndorsements() {
  const carousels = document.querySelectorAll("[data-expert-endorsements-swiper]");

  if (!carousels.length || !window.Swiper) return;

  carousels.forEach((carousel) => {
    if (carousel.dataset.initialized === "true") return;

    carousel.dataset.initialized = "true";

    const prevButton = carousel.querySelector("[data-expert-endorsements-prev]");
    const nextButton = carousel.querySelector("[data-expert-endorsements-next]");
    const pagination = carousel.querySelector("[data-expert-endorsements-pagination]");
    const slideCount = carousel.querySelectorAll(".swiper-slide").length;

    if (!slideCount) return;

    const config = {
      slidesPerView: 1.2,
      spaceBetween: 20,
      loop: slideCount > 1,
      speed: 500,
      centeredSlides: true,
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 24,
          centeredSlides: false,
          loop: false,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 19,
          centeredSlides: false,
          loop: false,
        },
      },
    };

    if (prevButton && nextButton) {
      config.navigation = {
        prevEl: prevButton,
        nextEl: nextButton,
      };
    }

    if (pagination) {
      config.pagination = {
        el: pagination,
        clickable: true,
      };
    }

    new window.Swiper(carousel, config);
  });
}
